interface AnalysisInProgressScreenProps {
  onBack?: () => void;
}

export function AnalysisInProgressScreen({ onBack }: AnalysisInProgressScreenProps) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        {/* Animated spinner icon */}
        <div className="mb-4">
          <div className="mx-auto h-12 w-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Analysis in Progress
        </h1>

        {/* Main message */}
        <p className="text-gray-600 mb-4">
          This package is currently being analyzed. Please check back in a few minutes.
        </p>

        {/* Help text */}
        <p className="text-sm text-gray-500 mb-6">
          You'll be able to view the full report once the analysis is complete.
        </p>

        {/* Back button */}
        {onBack && (
          <button
            onClick={onBack}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Back to Reports
          </button>
        )}
      </div>
    </div>
  );
}
